export const WIZARD_INFO = 'info';
export const WIZARD_ADDRESS = '11';
export const WIZARD_BUILD = '21';
export const WIZARD_BUDGET = '31';
export const WIZARD_QUOTA = '41';
export const WIZARD_ACCOUNT = '51';